//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
import { ICuralateSession } from 'app/basic-session/ICuralateSession';
import { crl8 } from 'app/curalate.globals';

export default function SessionReducer(state: ICuralateSession | undefined): ICuralateSession {
  return state || crl8.session!;
}
